import { Button, message } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Toaster } from "react-hot-toast";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import { RiInstagramFill } from "react-icons/ri";
import { useWindowSize } from "react-use";
import { AuthContext } from "../../Contexts/AuthContext";
import { ConfigContext } from "../../Contexts/ConfigContext";
import axios from "../../config/axios";
import Footer from "../Footer/Footer";
import LocationModal from "../LocationModal/LocationModal";
import MobileBottomBar from "../MobileBottomBar/MobileBottomBar";
import AppHeader from "../AppHeader/AppHeader";
import Chat from "./Chat/Chat";
import styles from "./Layout.module.scss";
import { PreFooter } from "./Containers/PreFooter";

const Layout = (props) => {
  const { location } = useContext(AuthContext);
  const { showLocModal, setShowLocModal } = useContext(ConfigContext);

  const [mobileSearch, setMobileSearch] = useState(false);

  const [email, setEmail] = useState("");
  const [join, setJoin] = useState(false);

  const FloatingLocationBarMobileRef = useRef(null);

  //defining handleNewsletterOptIn function
  const handleNewsletterOptIn = (e) => {
    e.preventDefault();

    axios.post("/newsletter/subscribe", { email: email }).then((response) => {
      message.success("Registered successfully!");
    });
  };

  useEffect(() => {
    // setting floating location bar bottom position
    const bottomBar = document.getElementById("mobile-bottom-bar");
    const floatingLocationBarMobile = FloatingLocationBarMobileRef.current;
    if (floatingLocationBarMobile && bottomBar) {
      floatingLocationBarMobile.style.bottom =
        bottomBar.clientHeight + 3 + "px";
    }
  }, []);

  useEffect(() => {
    if (props.title) {
      document.title = props.title;
    }
  }, [props.title]);

  const { width } = useWindowSize();

  return (
    <div style={{ overflowX: "hidden", position: "relative", minHeight: "100vh" }}>
      <AppHeader mobileSearch={mobileSearch} setMobileSearch={setMobileSearch} />

      <div className={styles.main_body_wrapper}>{props.children}</div>

      <PreFooter {...props} />
      <br className="dt_only" />
      {/*desktop only layout section end*/}

      {!(props.hideNewsletter && window.innerWidth < 576) && (
        <section
          className={styles.newsletter}
          style={{
            display:
              (window.location.pathname.includes("/category") ||
                window.location.pathname.includes("/products")) &&
              width < 576
                ? "none"
                : "",
          }}
        >
          <div className={styles.newsletter__body + " container"}>
            <div className={styles.newsletter__body__left}>
              <div>
                <img src="/icon/mail-icon.svg" alt="" />
                <span style={{ fontSize: "1.8rem", textWrap: "nowrap" }}>
                  Stay connected with the community
                </span>
              </div>
              <form
                style={{ display: "flex", alignItems: "center" }}
                onSubmit={handleNewsletterOptIn}
              >
                {join ? (
                  <div className="d-flex flex-column">
                    <div>
                      <input
                        className={styles.jn_submit_input}
                        required
                        onChange={(e) => setEmail(e.target.value)}
                        type="email"
                        placeholder="Your E-Mail Address..."
                        value={email ?? ""}
                      />
                      <button
                        className={styles.jn_submit_btn}
                        style={{ cursor: "pointer" }}
                      >
                        Submit
                      </button>
                    </div>
                    <div className="mt-3 d-flex">
                      <input
                        id="agreement"
                        type="checkbox"
                        required
                        name="agreement"
                        style={{ width: "unset" }}
                      />
                      <label
                        htmlFor="agreement"
                        style={{
                          color: "white",
                          marginLeft: "2rem",
                          flex: "1",
                        }}
                      >
                        By subscribing, you agree to receive our newsletter and
                        accept our Privacy Policy. You can unsubscribe at any
                        time
                      </label>
                    </div>
                  </div>
                ) : (
                  <button
                    type={"button"}
                    onClick={() => setJoin(true)}
                    style={{ cursor: "pointer" }}
                  >
                    Join Now
                  </button>
                )}
              </form>
            </div>
            <div className={styles.newsletter__body__right}>
              <a
                href="https://www.facebook.com/dfresh.de"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebookF size={20} color={"var(--color-light)"} />
              </a>
              <a
                href="https://twitter.com/DesiFresh_de"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaTwitter size={20} color={"var(--color-light)"} />
              </a>
              <a
                href="https://www.linkedin.com/company/desi-fresh"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaLinkedinIn size={20} color={"var(--color-light)"} />
              </a>
              <a
                href="https://www.youtube.com/channel/UCPZDCA-MzmVJKRQ4FvCclCw"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaYoutube size={20} color={"var(--color-light)"} />
              </a>
              <a
                href="https://www.instagram.com/dfresh_de"
                target="_blank"
                rel="noopener noreferrer"
              >
                <RiInstagramFill size={20} color={"var(--color-light)"} />
              </a>
              {/*<Link to="/">*/}
              {/*    <FaMobileAlt size={15} color={'var(--color-light)'} style={{marginRight: '.5rem'}}/>*/}
              {/*    <span style={{color: 'var(--color-light)'}}>Mobile apps</span>*/}
              {/*</Link>*/}
            </div>
          </div>
        </section>
      )}

      {/*footer component*/}
      {!(props.hideFooter && window.innerWidth < 576) && <Footer />}

      {/* Toaster Setting */}
      <Toaster
        position={"bottom-center"}
        toastOptions={{
          duration: 1000,
          style: {
            background: "var(--color-dark)",
            color: "var(--color-light)",
            border: "2px solid var(--color-dark)",
          },
          success: {
            style: {
              background: "var(--color-dark)",
              color: "var(--color-light)",
              border: "2px solid var(--color-dark)",
            },
          },
          error: {
            style: {
              background: "var(--color-dark)",
              color: "var(--color-light)",
              border: "2px solid var(--color-dark)",
            },
          },
        }}
      />
      {/* Chat Component */}
      {!props.disableChat && <Chat />}

      {/*Location Modal component*/}
      {showLocModal && <LocationModal setShowLocModal={setShowLocModal} />}

      {/*Floating Location Bar*/}
      {window.innerWidth <= 576 ? (
        <>
          {" "}
          {!location && (
            <div
              ref={FloatingLocationBarMobileRef}
              className={styles.floating_location_bar_mobile}
              onClick={() => setShowLocModal(true)}
            >
              <img src="/icon/desktop/df-g-map-mobile.png" alt="map" />
              <div className="d-flex flex-column justify-content-center gap-3 py-3 px-4">
                {location ? (
                  <span className="text-center">
                    <span style={{ fontWeight: "bold" }}>
                      Selected Location:
                    </span>{" "}
                    {location.city}, Zip code: {location.zip}
                  </span>
                ) : (
                  <span className="text-center fs-3 lh-1">
                    See the products available near you.
                  </span>
                )}

                <Button type={"primary"} size={"medium"} block>
                  {location ? "Change Address" : "Add Address"}
                </Button>
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          {!location && (
            <div
              className={styles.floating_location_bar}
              onClick={() => setShowLocModal(true)}
            >
              <div>
                <img src="/icon/desktop/df-g-map.png" alt="" />
                {location ? (
                  <span>
                    <span style={{ fontWeight: "bold" }}>
                      Selected Location:
                    </span>{" "}
                    {location.city}, Zip code: {location.zip}
                  </span>
                ) : (
                  <span>
                    Add your address to see products available near you.
                  </span>
                )}
              </div>

              <Button
                type={"primary"}
                size={"large"}
                style={{ marginRight: "15px" }}
              >
                {location ? "Change Address" : "Add Address"}
              </Button>
            </div>
          )}
        </>
      )}

      {/* mobile bottom bar render */}
      <section className={styles.mobile_bottom_bar}>
        <MobileBottomBar
          mobileSearch={mobileSearch}
          setMobileSearch={setMobileSearch}
        />
      </section>
    </div>
  );
};

export default Layout;
